import { api } from './index'

export type InsightsLabItem = {
  id: string
  title: string
  description: string
  category: string
}

export const insightsLabApi = api.injectEndpoints({
  endpoints: builder => ({
    getInsightsLab: builder.query<InsightsLabItem[], void>({
      query: () => 'looker/insights_lab',
      providesTags: ['InsightsLab'],
    }),
    getDashboard: builder.query<InsightsLabItem, string>({
      query: id => `looker/insights_lab/${id}`,
      providesTags: ['InsightsLab'],
    }),
  }),
  overrideExisting: false,
})

export const { useGetInsightsLabQuery, useGetDashboardQuery } = insightsLabApi
